import React from 'react';
import { useNavigate } from "react-router-dom";
import "./Slider.css";
import bg from "../../Asstets/bg.mp4"; // ✅ correct path

const Slider = () => {
  const navigate = useNavigate();

  return (
    <div className="pro-hero-wrapper">

      <div className="video-background">
        <video 
          className="video-asset" 
          src={bg} 
          autoPlay 
          loop 
          muted 
          playsInline 
        />
        <div className="video-vignette"></div>
      </div>

      <div className="pro-container">

        <div className="hero-header">
          <span className="est-tag">ESTABLISHED 2022</span>
          <div className="status-indicator">
            <span className="dot"></span>
            SYSTEM ACTIVE
          </div>
        </div>

        <div className="hero-main">
          <h1 className="hero-display">
            SKYLINE <br />
            <span className="hero-sub-display">Bussiness Solutions</span>
          </h1>
          
          <div className="hero-details">
            <p className="hero-lead">
              Innovating the Digital Frontier. We engineer <strong>scalable systems</strong>.
            </p>
            
            <div className="hero-actions">
              <button onClick={() => navigate("/servicehomepage")} className="btn-filled">
                Our Services
              </button>

              <button onClick={() => navigate("/contact")} className="btn-ghost">
                Get in Touch —
              </button>
            </div>
          </div>
        </div>

        <div className="hero-footer">
          <div className="footer-stat">
            <span className="stat-value">487+</span>
            <span className="stat-label">Enterprise Partners</span>
          </div>
          <div className="footer-stat">
            <span className="stat-value">2026</span>
            <span className="stat-label">Digital Innovation</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Slider;